import _ from 'lodash';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';

/**
 * This is a native browser rich text editor that
 * provides the same API as a React textarea
 * - `value` setter (on the React component)
 * - `value` getter (on the DOM node)
 * - onChange event handler
 */

const ContentEditableDiv = createReactClass({
  propTypes: {
    onChange: PropTypes.func,
    value: PropTypes.string,
    className: PropTypes.string,
  },

  // content-editable fires the onInput event
  // so this transforms those events to the onChange
  // giving this component the same API as other DOM controls
  onInput() {
    let currHtml = this.domNode().innerHTML;

    if (this.props.onChange) {
      this.props.onChange({ target: { value: currHtml } });
    }

    this.setState({ value: currHtml });
    this.domNode().value = currHtml;
  },

  getInitialState() {
    return { value: this.props.value };
  },

  componentDidMount() {
    this.domNode().value = this.domNode().innerHTML;
  },

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ value: nextProps.value });
  },

  // prevent "controlled" rendering (the state should equal the innerHTML while editing)
  // because "controlled" React rendering and content-editable is buggy
  shouldComponentUpdate(nextProps, nextState) {
    // only update when there are changes to prevent caret jumping
    if (this.domNode().innerHTML !== nextState.value) {
      this.domNode().innerHTML = nextState.value;
      this.domNode().value = nextState.value;
    }

    // never fall back to React render
    return false;
  },

  domNode() {
    return ReactDOM.findDOMNode(this);
  },

  render() {
    /* eslint-disable react/no-danger */
    return (
      <div
        className={`content-editable ${this.props.className}`}
        {..._.omit(this.props, 'className')}
        contentEditable="true"
        onInput={this.onInput}
        dangerouslySetInnerHTML={{ __html: this.state.value || '' }}
      />
    );
    /* eslint-enable react/no-danger */
  },
});

export default ContentEditableDiv;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/dom_controls/lib/content_editable_div.js